'use client';

import ClientPortal from 'components/helper/client-portal';
import styles from './footnote.module.scss';
import { useRef, useState } from 'react';
import RichTextInline from 'components/rich-text/rich-text-inline-only';
import ModalBackground from 'components/collection/modal-viewer/modal-background';
import CloseButton from 'assets/icons/close-x.svg';
import { ArrowContainer, Popover } from 'react-tiny-popover';
import tooltipStyles from 'components/tooltip/tooltip.module.scss';
import useMediaQuery from 'hooks/use-media-query';
import { BREAKPOINT_M } from 'lib/constants.mjs';

export const FootnotePopup = ({ body }) => {
	const footnoteRef = useRef<HTMLButtonElement>(null);
	const [modalOpen, setModalOpen] = useState(false);
	const modalRef = useRef(null);
	const { matches: isMobile } = useMediaQuery(`(max-width: ${BREAKPOINT_M}px)`);

	const handleClick = () => {
		setModalOpen(true);
	};

	const handleOutsideClick = (event) => {
		// Close modal if the click target is outside the modal container
		if (modalRef.current && !modalRef.current.contains(event.target)) {
			setModalOpen(false);
		}
	};

	const handleClose = () => {
		setModalOpen(false);
	};

	return (
		<>
			<span className={styles.wrapper}>
				<Popover
					padding={4}
					containerClassName={tooltipStyles.tooltip}
					onClickOutside={handleClose}
					isOpen={modalOpen && !isMobile}
					positions={['bottom', 'right', 'left', 'top']} // preferred positions by priority
					content={({ position, childRect, popoverRect }) => (
						<ArrowContainer
							position={position}
							childRect={childRect}
							popoverRect={popoverRect}
							arrowColor={'var(--color-site-background)'}
							arrowSize={10}
						>
							<div className={tooltipStyles.content}>
								<RichTextInline value={body} />
							</div>
						</ArrowContainer>
					)}
				>
					<button
						ref={footnoteRef}
						className={styles.footnote}
						onClick={handleClick}
					/>
				</Popover>
			</span>
			{modalOpen && isMobile ? (
				<ClientPortal>
					<ModalBackground onClick={handleOutsideClick} mode="subtle">
						<div className={styles.modal} ref={modalRef}>
							<button className={styles.close} onClick={handleClose}>
								<CloseButton />
							</button>
							<RichTextInline value={body} />
						</div>
					</ModalBackground>
				</ClientPortal>
			) : null}
		</>
	);
};

export default FootnotePopup;
